module.exports = require("./ar-OM.d.ts");